import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/all' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';
  const isTransparent = isHome && !scrolled && !mobileOpen;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`flex items-center gap-2 cursor-pointer ${
              isTransparent ? 'text-background-50' : 'text-foreground-900'
            }`}
          >
            <span className="text-xl font-heading font-bold whitespace-nowrap">韩漫世界</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-label whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? isTransparent
                      ? 'text-background-50 font-semibold'
                      : 'text-primary-500 font-semibold'
                    : isTransparent
                      ? 'text-background-50/80 hover:text-background-50'
                      : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <button
              className={`text-sm font-label whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                isTransparent ? 'text-background-50/80 hover:text-background-50' : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              <i className="ri-search-line mr-1" />
              搜索
            </button>
            <button className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-colors duration-200">
              登录
            </button>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-lg ${
              isTransparent ? 'text-background-50' : 'text-foreground-900'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-label py-2 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-500 font-semibold'
                    : 'text-foreground-700'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="border-t border-background-200/70 pt-3 mt-1 flex gap-3">
              <button className="flex-1 text-sm font-label py-2 text-foreground-600 cursor-pointer whitespace-nowrap">
                <i className="ri-search-line mr-1" /> 搜索
              </button>
              <button className="flex-1 bg-primary-500 text-background-50 py-2 rounded-full text-sm font-label whitespace-nowrap cursor-pointer">
                登录
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}